import { Navigate, useParams } from "react-router-dom";

export function LegacyPrintRedirect() {
  const { projectId } = useParams<{ projectId: string }>();
  return <Navigate to={legacyPrintRedirectTarget(projectId)} replace />;
}

export function isValidPrintProjectId(
  projectId: string | undefined
): projectId is string {
  return typeof projectId === "string" && /^[1-9]\d*$/.test(projectId);
}

export function canonicalPrintStudioPath(projectId: string): string {
  return `/gis/${projectId}/studio`;
}

export function legacyPrintRedirectTarget(
  projectId: string | undefined
): string {
  return isValidPrintProjectId(projectId)
    ? canonicalPrintStudioPath(projectId)
    : "/projects";
}
